import HeadingView, { HeadingVariant } from "../views/heading/Heading.view";


export const H1 = (props) => (
	<HeadingView viewKey="heading.h1" variant={HeadingVariant.H1}>
		{props.children}
	</HeadingView>
);

export const H2 = (props) => (
	<HeadingView viewKey="heading.h2" variant={HeadingVariant.H2}>
		{props.children}
	</HeadingView>
);

export const H3 = (props) => (
	<HeadingView viewKey="heading.h3" variant={HeadingVariant.H3}>
		{props.children}
	</HeadingView>
);

export const H4 = (props) => (
	<HeadingView viewKey="heading.h4" variant={HeadingVariant.H4}>
		{props.children}
	</HeadingView>
);

export const H5 = (props) => (
	<HeadingView viewKey="heading.h5" variant={HeadingVariant.H5}>
		{props.children}
	</HeadingView>
);

export const H6 = (props) => (
	<HeadingView viewKey="heading.h6" variant={HeadingVariant.H6}>
		{props.children}
	</HeadingView>
);

const Heading = {
	H1,
	H2,
	H3,
	H4,
	H5,
	H6
};

export default Heading;




// WEBPACK FOOTER //
// ./src/common/fragments/Heading.tsx